@if (isInitialLoading && !isInitialError) {
  <sh-page id="home-page-1" [scrollable]="false" layout="normal" [theme]="theme">
    <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
      <sh-spinner id="home-spinner-2"></sh-spinner>
    </div>
  </sh-page>
}



@if (!isInitialLoading && !isInitialError && showMainApplication && screenInfo$ | async; as screen) {
  <sh-page id="home-page-3"
    scrollable="false" [theme]="theme" layout="normal" access-bar="solid">
    <!-- Access Bar -->
    <sh-access-bar id="home-access-bar-4" [label]='title' slot='access' layout='classic'>
      <!-- <sh-icon id="home-icon-saved-bookmarks" aria-label="Saved Bookmarks" size="s" icon="bookmark" button toggle slot="functions"></sh-icon> -->
      <span [attr.aria-label]="'home.accessBar.languageSelector' | transloco" id="target-lang" #langTrigger slot="functions"
        class="lang-flag-trigger" [class.lang-flag-trigger--active]="langPopoverVisible"
        (click)="toggleLangPopover()">
        <span class="fi fi-{{currentLanguage.flagCode}} lang-flag-icon"></span>
      </span>
      @if (!hasNewNotifications) {
        <sh-icon [attr.aria-label]="'home.accessBar.notificationCenter' | transloco" #noticenter size="s" id="target-2a"
        icon="notification-center" button toggle slot="functions"></sh-icon>
      }
      @if (hasNewNotifications) {
        <sh-icon [attr.aria-label]="'home.accessBar.notificationCenter' | transloco" #noticenter size="s" id="target-2a"
        icon="notification-center" button toggle slot="functions" [badge]="numberOfNotifications"></sh-icon>
      }
      <sh-icon id="home-icon-circle-half" icon="circle-half" button slot="functions" (click)="switchTheme()">
      </sh-icon>
      @if (userData['photo'] !== null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo' image="url({{userData['photo']}})"></sh-user-identifier>
      }
      @if (userData['photo'] === null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo'></sh-user-identifier>
      }
      <sh-icon [attr.aria-label]="'home.accessBar.appSettings' | transloco" #settings id="target-1a" icon="more" button toggle
      slot="functions"></sh-icon>
    </sh-access-bar>
    <!-- Left Pane -->
    @if (getDeviceType() !== 'phone') {
      <sh-pane id="home-pane-9" #leftpane slot='left' behavior='condense'
        [size]="definePaneSizeLeft(screen.size)" style="z-index: 3;">
        <!-- Expanded -->
        <div [attr.role]="'listbox'" #paneItems [attr.id]="'dropdown-list'" [attr.aria-label]="'Main Options'">
          <sh-menu-item id="home-menu-item-home" [attr.role]="'option'" [attr.aria-selected]="true" icon="home" [attr.label]="'home.nav.home' | transloco" icon-size="xs"
          active (click)="newChat($event)"></sh-menu-item>
          <!-- <sh-menu-item id="home-menu-item-settings" [attr.role]="'option'" [attr.aria-selected]="true" icon="settings"
          label='Manage Alert Subscriptions' [toggle]="false" icon-size="xs"
        (click)="openModalSubscription()"></sh-menu-item> -->
        @if (bpCanChatbot || bpShowDisabledChatbot) {
          <sh-menu-item id="home-menu-item-plus" [attr.role]="'option'" [attr.aria-selected]="true"
            [attr.aria-disabled]="!bpCanChatbot" [disabled]="!bpCanChatbot" [class.bp-disabled-chat-entry]="!bpCanChatbot"
          icon="plus" [attr.label]="'home.nav.startNewChat' | transloco" icon-size="xs" (click)="newChat($event)"></sh-menu-item>
        }
      </div>
      @if (bpCanChatbot) {
        <app-chathistory></app-chathistory>
      }
      @if (bpShowDisabledChatbot) {
        <sh-empty-state id="home-empty-state-please-contact-your-sieme" class="bp-disabled-chat-history"
          [attr.header]="'home.chatHistory.disabled.header' | transloco"
          [attr.label]="'home.chatHistory.disabled.message' | transloco"
        icon="message-history" icon-color="grey"></sh-empty-state>
      }
      <div #paneTools slot="condensed" style="display: flex; flex-direction: column; gap: 8px;">
        <sh-tool id="home-tool-14" slot='condensed' [attr.label]="'home.nav.home' | transloco" icon='home' active toggle (click)="newChat($event)"></sh-tool>
        <!-- <sh-tool id="home-tool-15" slot='condensed' label='Subscriptions' icon='settings' (click)="openModalSubscription()"></sh-tool> -->
        @if (bpCanChatbot || bpShowDisabledChatbot) {
          <sh-tool id="home-tool-16" slot='condensed' [attr.label]="'home.nav.newChat' | transloco" icon='plus' toggle
          [disabled]="!bpCanChatbot" [class.bp-disabled-chat-entry]="!bpCanChatbot" (click)="newChat($event)"></sh-tool>
        }
        @if (bpCanChatbot || bpShowDisabledChatbot) {
          <sh-tool id="home-tool-17" slot='condensed' [attr.label]="'home.nav.chatHistory' | transloco" toggle icon='message-history'
            [disabled]="!bpCanChatbot" [class.bp-disabled-chat-entry]="!bpCanChatbot"
          (click)="openChatHistory($event)"></sh-tool>
        }
      </div>
    </sh-pane>
  }
  <!-- Right Pane -->
  @if (getDeviceType() !== 'phone') {
    <sh-pane id="home-pane-18" slot='right' behavior='collapse'
      [size]="definePaneSizeRight(screen.size)">
      <div #sidearea cdkScrollable style="display: flex; flex-direction: column; gap: 16px; overflow-y: auto;">
        <div class="bp-search-row">
          @if (!bpCanSearchContent) {
            <div class="bp-search-row__lock">
              <sh-icon id="bp-search-lock" class="bp-search-row__lock-icon" icon="lock" size="s"
              [attr.aria-label]="'home.search.lockAriaLabel' | transloco"></sh-icon>
              <sh-popover id="home-popover-19" target="bp-search-lock" type="info" position="bottom" [passive]="true"
                style="max-width: 320px; z-index: 500;">
                {{ 'home.search.lockPopover' | transloco }}
              </sh-popover>
            </div>
          }
          <div #searcharea class="bp-search-area" [class.bp-search-area--disabled]="!bpCanSearchContent" [attr.aria-disabled]="!bpCanSearchContent"
            style="display: flex; align-items: center; width: 100%; gap: 4px;">
            <app-autocomplete [disabled]="!bpCanSearchContent" style="flex: 1 0 63%;"></app-autocomplete>
            @if (getDeviceType() !== 'phone') {
              <i #bookmarkicon class="pi pi-bookmark-fill bookmark-custom"
                (click)="bpCanSearchContent ? onMaximizeBookmarks() : null"
              [ngClass]="{'active': bpCanSearchContent && selectedBottom === 'bookmark' && bottomSize !== 'small', 'bookmark-custom-disabled': !bpCanSearchContent}" id="bookmarkicon"></i>
            }
            @if (getDeviceType() === 'phone') {
              <i class="pi pi-bookmark-fill bookmark-custom"
              [ngClass]="{'active': bookmarksOpen}" id="bookmarkiconmobile"></i>
            }
            <!-- <sh-popover id="home-popover-20" *ngIf="getDeviceType() !== 'phone'" #bookmarkmenu sticky passive position="left-up"
            target="bookmarkicon" overlay-target-distance="1" viewport-padding="0.5"
            style="width:600px ; z-index: 500" [visible]="bookmarksOpen" (overlay-closed)="bookmarksClosed()">
            <app-bookmark-menu></app-bookmark-menu>
          </sh-popover> -->
          <!-- Mobile Bookmarks -->
          @if (getDeviceType() === 'phone') {
            <sh-popover id="home-popover-21" mobile target="bookmarkiconmobile">
              <app-bookmark-menu></app-bookmark-menu>
            </sh-popover>
          }
        </div>
      </div>
      <ng-template #lockedWidgetCard let-icon="icon" let-title="title" let-subtitle="subtitle"
        let-rangeLabel="rangeLabel" let-message="message">
        <sh-box id="home-box-22" class="bp-disabled-widget-card" background="surface-tertiary" layout="vertical"
          elevation="none">
          <sh-box-header id="home-box-header-23" slot="header" padding-bottom="0">
            <sh-icon id="home-icon-24" [icon]="icon" size="s" class="bp-disabled-widget-icon"></sh-icon>
            <div class="bp-disabled-widget-heading">
              <sh-text id="home-text-25" size="title-1">{{title}}</sh-text>
              @if (subtitle) {
                <sh-text id="home-text-26" size="body-1" color="secondary">{{subtitle}}</sh-text>
              }
            </div>
            @if (rangeLabel) {
              <sh-dropdown id="home-dropdown-27" no-border disabled condensed style="max-width: 120px;">
                <sh-menu-item id="home-menu-item-28" [label]="rangeLabel" active></sh-menu-item>
              </sh-dropdown>
            }
          </sh-box-header>
          <sh-box-section id="home-box-section-29" class="bp-disabled-widget-section">
            <sh-empty-state id="home-empty-state-lock" [label]="message" icon="lock" icon-color="grey"></sh-empty-state>
          </sh-box-section>
        </sh-box>
      </ng-template>
      <!-- Device Widgets -->
      @if (this.selectedContentService.selection.kind == 'device') {
        <!-- Header widget: always pinned at top, not draggable -->
        <app-header-widget></app-header-widget>
        <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="onWidgetDrop($event, 'device')" class="widget-drop-list">
          @for (widgetId of visibleDeviceWidgets; track widgetId) {
            <div cdkDrag class="widget-drag-item">
              <ng-template cdkDragPlaceholder>
                <div class="widget-placeholder" [style.height.px]="dragPlaceholderHeight"></div>
              </ng-template>
              <div class="widget-drag-handle" cdkDragHandle (pointerdown)="onDragHandlePointerDown($event)">
                <sh-icon icon="draggable-horizontal-s" size="xs"></sh-icon>
              </div>
              @switch (widgetId) {
                @case ('instrument') {
                  <app-instrument style="flex: 1 1 auto;"></app-instrument>
                }
                @case ('upcoming') {
                  <app-upcoming-activities style="flex: 1 1 auto;"></app-upcoming-activities>
                }
                @case ('service-history') {
                  <app-service-history style="flex: 1 1 auto;"></app-service-history>
                }
                @case ('funcloc') {
                  <app-funcloc style="flex: 1 1 auto;"></app-funcloc>
                }
                @case ('service-metrics') {
                  <app-service-metrics style="flex: 1 1 auto;"></app-service-metrics>
                }
              }
            </div>
          }
        </div>
        <!-- Locked device widgets (not draggable) -->
        @for (widgetId of lockedDeviceWidgets; track widgetId) {
          @switch (widgetId) {
            @case ('instrument') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'open-tasks',
                  title: ('home.lockedWidget.systemHealth.title' | transloco),
                  rangeLabel: ('home.lockedWidget.systemHealth.range' | transloco),
                  message: ('home.lockedWidget.systemHealth.message' | transloco)
              }"></ng-container>
            }
            @case ('funcloc') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'manufacturer',
                  title: ('home.lockedWidget.locationOfDevice.title' | transloco),
                  rangeLabel: ('home.lockedWidget.locationOfDevice.range' | transloco),
                  message: ('home.lockedWidget.locationOfDevice.message' | transloco)
              }"></ng-container>
            }
            @case ('upcoming') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'service-login',
                  title: ('home.lockedWidget.upcomingServices.title' | transloco),
                  rangeLabel: ('home.lockedWidget.upcomingServices.range' | transloco),
                  message: ('home.lockedWidget.upcomingServices.message' | transloco)
              }"></ng-container>
            }
            @case ('service-history') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'utilities',
                  title: ('home.lockedWidget.serviceHistory.title' | transloco),
                  rangeLabel: ('home.lockedWidget.serviceHistory.range' | transloco),
                  message: ('home.lockedWidget.serviceHistory.message' | transloco)
              }"></ng-container>
            }
            @case ('service-metrics') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'kpi',
                  title: ('home.lockedWidget.serviceMetrics.title' | transloco),
                  rangeLabel: ('home.lockedWidget.serviceMetrics.range' | transloco),
                  message: ('home.lockedWidget.serviceMetrics.message' | transloco)
              }"></ng-container>
            }
          }
        }
      }
      <!-- Site Widgets -->
      @if (this.selectedContentService.selection.kind == 'site') {
        <app-funcloc type="site"></app-funcloc>
        <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="onWidgetDrop($event, 'site')" class="widget-drop-list">
          @for (widgetId of visibleSiteWidgets; track widgetId) {
            <div cdkDrag class="widget-drag-item">
              <ng-template cdkDragPlaceholder>
                <div class="widget-placeholder" [style.height.px]="dragPlaceholderHeight"></div>
              </ng-template>
              <div class="widget-drag-handle" cdkDragHandle (pointerdown)="onDragHandlePointerDown($event)">
                <sh-icon icon="draggable-horizontal-s" size="xs"></sh-icon>
              </div>
              @switch (widgetId) {
                @case ('upcoming') {
                  <app-upcoming-activities type="site" style="flex: 1 1 auto;"></app-upcoming-activities>
                }
                @case ('service-history') {
                  <app-service-history type="site" style="flex: 1 1 auto;"></app-service-history>
                }
                @case ('service-metrics') {
                  <app-service-metrics type="site" style="flex: 1 1 auto;"></app-service-metrics>
                }
              }
            </div>
          }
        </div>
        <!-- Locked site widgets (not draggable) -->
        @for (widgetId of lockedSiteWidgets; track widgetId) {
          @switch (widgetId) {
            @case ('upcoming') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'service-login',
                  title: ('home.lockedWidget.upcomingServices.title' | transloco),
                  rangeLabel: ('home.lockedWidget.upcomingServices.range' | transloco),
                  message: ('home.lockedWidget.upcomingServices.message' | transloco)
              }"></ng-container>
            }
            @case ('service-history') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'utilities',
                  title: ('home.lockedWidget.serviceHistory.title' | transloco),
                  rangeLabel: ('home.lockedWidget.serviceHistory.range' | transloco),
                  message: ('home.lockedWidget.serviceHistory.message' | transloco)
              }"></ng-container>
            }
            @case ('service-metrics') {
              <ng-container *ngTemplateOutlet="lockedWidgetCard; context: {
                  icon: 'kpi',
                  title: ('home.lockedWidget.serviceMetrics.title' | transloco),
                  rangeLabel: ('home.lockedWidget.serviceMetrics.range' | transloco),
                  message: ('home.lockedWidget.serviceMetrics.message' | transloco)
              }"></ng-container>
            }
          }
        }
      }
      <!-- Placeholder Widgets -->
      @if (this.selectedContentService.selection.kind == 'none') {
        <sh-box id="home-box-31" style="flex-grow:0;"
          background="surface" layout="vertical" elevation="none" style="height: 100%">
          <sh-box-header id="home-box-header-32" slot="header" padding-bottom="0">
            <sh-icon id="home-icon-show-all-monitors" icon="show-all-monitors" size="s" style="margin-left: -2px; margin-right: 4px;"></sh-icon>
            <sh-text id="home-text-34" size="title-1">{{isContentLoading ? ('home.widgets.loadingTitle' | transloco) : ('home.widgets.title' | transloco)}}</sh-text>
            <!-- <sh-icon id="home-icon-information" icon="information" size="s" button [attr.aria-label]="'Information Service History'"></sh-icon> -->
            <sh-dropdown id="home-dropdown-36" [attr.label]="'home.widgets.dateRange' | transloco" no-border disabled condensed style="max-width: 100px;">
              <sh-menu-item id="home-menu-item-last-7-days" [attr.label]="'home.widgets.range.last7Days' | transloco" active></sh-menu-item>
            </sh-dropdown>
          </sh-box-header>
          @if (!isContentLoading) {
            <sh-box-section id="home-box-section-38" style="height: 100%">
              <sh-empty-state id="home-empty-state-39"
                [label]="bpCanSearchContent ? ('home.widgets.emptySearchable' | transloco) : ('home.widgets.emptyRestricted' | transloco)"
              [icon]="bpCanSearchContent ? 'search' : 'lock'"></sh-empty-state>
            </sh-box-section>
          }
          @if (isContentLoading) {
            <sh-box-section id="home-box-section-40" style="height: 100%">
              <sh-spinner id="home-spinner-41" size="s"></sh-spinner>
            </sh-box-section>
          }
        </sh-box>
      }
    </div>
  </sh-pane>
}
<!-- Phone Content -->
@if (getDeviceType() == 'phone') {
<div style="height: 100%; display: flex; flex-direction: column;
            padding: 16px 20px; gap: 16px;">
        <div #searcharea style="flex: 0 0 auto; display: flex; align-items: center;
              width: 100%; gap: 4px; min-width: 0;">
      <app-autocomplete style="flex: 1 1 auto; min-width: 0;"></app-autocomplete>
      <i #bookmarkicon class="pi pi-bookmark-fill bookmark-custom" (click)="openBookmarks()"
      [ngClass]="{'active': bookmarksOpen}" id="bookmarkicon"></i>
      <sh-popover id="home-popover-42" #bookmarkmenu [sticky]="getDeviceType() !== 'phone'" passive position="left-up"
        target="bookmarkicon" overlay-target-distance="1" viewport-padding="0.5"
        style="width:450px; z-index: 500;" [visible]="bookmarksOpen" (overlay-closed)="bookmarksClosed()">
        <app-bookmark-menu></app-bookmark-menu>
      </sh-popover>
    </div>
    <div style="flex: 0 0 auto;">
      <sh-box id="home-box-43" background="surface-secondary" padding="compact">
        <sh-box-section id="home-box-section-44">
          <div style="display: flex; align-items: center; gap: 12px;">
            <sh-icon id="home-icon-warning" icon="warning" size="s"></sh-icon>
            <sh-text id="home-text-46">{{ 'home.mobile.warning' | transloco }}</sh-text>
          </div>
        </sh-box-section>
      </sh-box>
    </div>
    <app-header-widget style="flex: 0 0 auto;"></app-header-widget>
    <app-instrument style="flex: 0 0 auto;"></app-instrument>
    <app-service-history style="flex: 0 0 auto;"></app-service-history>
    <app-funcloc style="flex: 0 0 auto;"></app-funcloc>
    @if (showServiceMetricsWidget) {
      <app-service-metrics style="flex: 0 0 auto;"></app-service-metrics>
    }
  </div>
}
<!-- Main Content -->
@if (getDeviceType() !== 'phone') {
  <div style="height: 100%; display: flex; flex-direction: column; position: relative; overflow: hidden;">
    @if (bpCanChatbot && bottomSize !== 'fullscreen') {
      <app-chatbot [ngClass]="'top'"></app-chatbot>
    }
    @if (bpShowDisabledChatbot) {
      <sh-box id="home-box-47" class="bp-disabled-chat-shell top" background="surface-secondary"
        layout="vertical" elevation="none">
        <sh-box-section id="home-box-section-48" class="bp-disabled-chat-shell__section">
          <div class="bp-disabled-chat-shell__content">
            <sh-text id="home-text-49" class="display-500 bp-disabled-chat-shell__title">{{ 'home.chatDisabled.title' | transloco }}</sh-text>
            <sh-text id="home-text-50" size="body-1" color="secondary" class="bp-disabled-chat-shell__subtitle">
              {{ 'home.chatDisabled.subtitle' | transloco }}
            </sh-text>
            <div class="bp-disabled-chat-shell__composer" aria-hidden="true">
              <sh-icon id="home-icon-panel" class="bp-disabled-chat-shell__composer-icon bp-disabled-chat-shell__composer-icon--leading" icon="panel" size="s"></sh-icon>
              <sh-icon id="home-icon-send-message" class="bp-disabled-chat-shell__composer-icon bp-disabled-chat-shell__composer-icon--trailing" icon="send-message" size="s"></sh-icon>
            </div>
            <div class="bp-disabled-chat-shell__prompt-grid" aria-hidden="true">
              <sh-button id="home-button-summarize-recent-service" disabled icon-position="left" icon="ai-generative" [attr.label]="'home.chatDisabled.prompt.summarize' | transloco"
              layout="classic" color="tertiary" size="auto"></sh-button>
              <sh-button id="home-button-explain-current-system-he" disabled icon-position="left" icon="ai-generative" [attr.label]="'home.chatDisabled.prompt.explain' | transloco"
              layout="classic" color="tertiary" size="auto"></sh-button>
              <sh-button id="home-button-show-recommended-next-ste" disabled icon-position="left" icon="ai-generative" [attr.label]="'home.chatDisabled.prompt.nextSteps' | transloco"
              layout="classic" color="tertiary" size="auto"></sh-button>
            </div>
          </div>
        </sh-box-section>
      </sh-box>
    }
    <app-work-area></app-work-area>
    @if (bpCanChatbot && bottomSize === 'fullscreen') {
      <app-chat-pip-mode style="position: absolute; bottom: 16px; right: 16px; z-index: 10;"></app-chat-pip-mode>
    }
    <sh-popover id="home-popover-57" style="width: 400px" #popover target="target-2a" position="bottom-right"
      (overlay-closed)="unToggleNoti()">
      <app-subscribed-notifications [mode]="'menulist'"></app-subscribed-notifications>
    </sh-popover>
    <!-- Language Selector Popover -->
    <sh-popover id="home-popover-lang" style="width: 260px" target="target-lang" position="bottom-right"
      [visible]="langPopoverVisible" (overlay-closed)="unToggleLang()" [attr.label]="'home.langSelector.label' | transloco">
      <sh-list id="language-selector-list" flat integrated>
        @for (lang of supportedLanguages; track lang.code) {
          <sh-list-item [label]="lang.label"
            [active]="lang.code === currentLanguage.code"
            clickable
            (click)="selectLanguage(lang)">
            <span slot="left" class="fi fi-{{lang.flagCode}} lang-flag-icon-list"></span>
          </sh-list-item>
        }
      </sh-list>
    </sh-popover>
  </div>
}

<!-- Modal fast Access Pane -->
<sh-modal style="margin: 0px; padding: 0px" [visible]="modalOpen.open" id='size-modal' [attr.label]="'home.modal.detailedView' | transloco"
  [attr.modal-height]='defineModalSize(screen.size,screen.screenHeight,"height")'
  [attr.modal-width]='defineModalSize(screen.size,screen.screenHeight,"width")' (modal-closed)="closeModal()">
  @if (modalOpen.modal === 'autocheck') {
    <app-autocheck></app-autocheck>
  }
  @if (modalOpen.modal === 'maintenance') {
    <app-maintenance></app-maintenance>
  }
  @if (modalOpen.modal === 'error') {
    <app-error></app-error>
  }
  @if (modalOpen.modal === 'eventlogs') {
    <app-event-logs></app-event-logs>
  }
  @if (modalOpen.modal === 'notification-details') {
    <app-ms-notifications-details></app-ms-notifications-details>
  }
  @if (modalOpen.modal === 'psm') {
    <app-psm></app-psm>
  }
  @if (modalOpen.modal === 'maintenance-failure-reasons') {
    <app-maintenance-failure-reasons
    ></app-maintenance-failure-reasons>
  }
  @if (modalOpen.modal === 'lastUpdatedDetails') {
    <app-instrument-last-updated></app-instrument-last-updated>
  }
  @if (modalOpen.modal === 'image-preview') {
    <app-image-preview></app-image-preview>
  }
</sh-modal>
<!-- Modal Help Section -->
<sh-modal [visible]="helpModalOpen.open" id='help-modal' [attr.label]="'home.modal.help' | transloco" icon="library" icon-size="xs"
  (modal-closed)="closeHelpModal()" modal-width="50vw" modal-height="auto">
  <app-help-modal></app-help-modal>
</sh-modal>
<!-- Modal Alert Subscription -->
<!-- <sh-modal [visible]="modalSubscriptions.open" id='subscription-modal' label='Manage your Alert Subscriptions'
(modal-closed)="closeModalSubscription()" modal-width="800px">
<app-alert-subscription></app-alert-subscription>
</sh-modal> -->
<!-- Modal fast App Tracking Consent -->
<sh-modal [visible]="modalTracking.open" [sticky]="modalTracking.type === 'newuser'"
  [attr.label]="'home.consent.title' | transloco" [attr.modal-height]='"auto"'
  (modal-closed)="closeModalTracking()" id="consentmodal" #consentmodal>
  @if (isBusinessPartnerNewUserConsentFlow) {
    <div class="tracking-consent-flow">
      <div class="tracking-consent-flow__stepper">
        <sh-stepper id="home-stepper-58" [value]="trackingConsentStep" color="primary">
          <sh-stepper-item id="home-stepper-item-accept-terms-of-use" [attr.label]="'home.consent.stepper.termsOfUse' | transloco"
            (click)="goToTrackingConsentStep(1)"
            [active]="trackingConsentStep === 1"
          [type]="getTermsOfUseStepState()"></sh-stepper-item>
          <sh-stepper-item id="home-stepper-item-app-tracking-cookies" [attr.label]="'home.consent.stepper.trackingCookies' | transloco"
            (click)="goToTrackingConsentStep(2)"
            [active]="trackingConsentStep === 2"
          [disabled]="!termsOfUseAccepted"></sh-stepper-item>
        </sh-stepper>
      </div>
      @if (trackingConsentStep === 1) {
        <div class="tracking-consent-flow__panel">
          <sh-text id="home-text-61">
            {{ 'home.consent.termsText' | transloco }}
          </sh-text>
          <sh-text id="home-text-62">
            {{ 'home.consent.termsReview' | transloco }}
            <a [href]="termsOfUsePdfUrl" target="_blank" rel="noopener noreferrer">{{ 'home.consent.termsLink' | transloco }}</a>
            {{ 'home.consent.termsSuffix' | transloco }}
          </sh-text>
          <div class="tracking-consent-flow__checkbox">
            <sh-checkbox id="home-checkbox-i-accept-the-terms-of-use" [active]="termsOfUseAccepted" [attr.label]="'home.consent.termsAcceptLabel' | transloco"
            (checked)="toggleTermsOfUseAccepted()"></sh-checkbox>
          </div>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="trackingConsentPreferencesContent"></ng-container>
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="trackingConsentPreferencesContent"></ng-container>
  }
  <ng-template #trackingConsentPreferencesContent>
    <div class="tracking-consent-flow__panel">
      <sh-text id="home-text-64">
        {{ 'home.consent.trackingText' | transloco }}
      </sh-text>
      <sh-text id="home-text-65">
        {{ 'home.consent.cookiesText' | transloco }} <a id="cookies">{{ 'home.consent.cookiesLink' | transloco }}</a> {{ 'home.consent.cookiesSuffix' | transloco }}
        <sh-tooltip id="home-tooltip-cookies-in-this-applicati" target="cookies"
          [attr.title]="'home.consent.cookiesTooltip' | transloco"
        placement="top" variation="long"></sh-tooltip>
      </sh-text>
      <sh-text id="home-text-67">
        {{ 'home.consent.revokeText' | transloco }}
      </sh-text>
      <sh-text id="home-text-68" class="tracking-consent-flow__selection-label">
        <b>{{ 'home.consent.selectionLabel' | transloco }}</b>
      </sh-text>
      <sh-radio-group id="home-radio-group-69">
        <sh-radio-button id="home-radio-button-70" [attr.label]="'home.consent.option.consent' | transloco" [active]="consentBool === true"
        (active-changed)="changeconsentBool(true)"></sh-radio-button>
        <sh-radio-button id="home-radio-button-71" [attr.label]="'home.consent.option.reject' | transloco" neutral [active]="consentBool !== true"
        (active-changed)="changeconsentBool(false)"></sh-radio-button>
      </sh-radio-group>
      <sh-text id="home-text-72" size='caption' class="tracking-consent-flow__caption">
        {{ 'home.consent.privacyText' | transloco }}
        <a [href]="privacyNoticeUrl" target="_blank" rel="noopener noreferrer">{{ 'home.consent.privacyLink' | transloco }}</a>.
      </sh-text>
    </div>
  </ng-template>
  @if (modalTracking.type !== 'newuser') {
    <sh-button id="home-button-73" color='secondary' slot='footer' [attr.label]="'home.consent.button.cancel' | transloco"
    (click)='closeModalTracking()'></sh-button>
  }
  @if (isBusinessPartnerNewUserConsentFlow && trackingConsentStep === 2) {
    <sh-button id="home-button-74" color='secondary' slot='footer' [attr.label]="'home.consent.button.back' | transloco"
    (click)='goToPreviousTrackingConsentStep()'></sh-button>
  }
  @if (isBusinessPartnerNewUserConsentFlow && trackingConsentStep === 1) {
    <sh-button id="home-button-75" slot='footer' [attr.label]="'home.consent.button.continue' | transloco"
    [disabled]="!termsOfUseAccepted" (click)='goToNextTrackingConsentStep()'></sh-button>
  }
  @if (!isBusinessPartnerNewUserConsentFlow || trackingConsentStep === 2) {
    <sh-button id="home-button-76" slot='footer' [attr.label]="'home.consent.button.save' | transloco" (click)='changeConsent()'></sh-button>
  }
</sh-modal>
<!-- Settings Popover -->
<sh-popover id="home-popover-77" style="width: 240px" #popover target="target-1a" position="bottom-right" (overlay-closed)="unToggle()">
  <sh-text id="home-text-78" size='title-1'>{{ 'home.settings.title' | transloco }}</sh-text>
  @if (bpShowBusinessPartnerManagerEntry) {
    <sh-menu-item id="home-menu-item-manage-business-partners" [attr.label]="'home.settings.manageBusinessPartners' | transloco" [toggle]="false"
      [attr.aria-disabled]="!bpCanManageBusinessPartners" [disabled]="!bpCanManageBusinessPartners"
    [class.bp-disabled-chat-entry]="!bpCanManageBusinessPartners" (click)="openBusinessPartnerManager()"></sh-menu-item>
  }
  <sh-menu-item id="home-menu-item-change-tracking-consent" [attr.label]="'home.settings.changeTrackingConsent' | transloco" [toggle]="false" (click)="openModalTracking()"></sh-menu-item>
  <!-- <sh-switch id="home-switch-81" stretch variant="squared">
  <sh-switch-item id="home-switch-item-82" icon='circle-filled' [active]="theme === 'light'" (click)="switchTheme('light')"></sh-switch-item>
  <sh-switch-item id="home-switch-item-83" icon='circle-outline' [active]="theme === 'light'" (click)="switchTheme('dark')"></sh-switch-item>
</sh-switch> -->
<sh-menu-item id="home-menu-item-supported-systems" [attr.label]="'home.settings.supportedSystems' | transloco" [toggle]="false"
(click)="document.querySelector('#info-modal')['visible'] = true"></sh-menu-item>
<sh-menu-item id="home-menu-item-provide-feedback" [attr.label]="'home.settings.provideFeedback' | transloco" [toggle]="false" (click)="openHelp('feedback')"></sh-menu-item>
<sh-menu-item id="home-menu-item-release-notes" [attr.label]="'home.settings.releaseNotes' | transloco" [toggle]="false" (click)="openHelp('versions')"></sh-menu-item>
<sh-divider id="home-divider-87"></sh-divider>
<sh-menu-item id="home-menu-item-terms-of-use" [attr.label]="'home.settings.termsOfUse' | transloco" [toggle]="false"
(click)="openURL(termsOfUseUrl,$event)"></sh-menu-item>
<!-- <sh-menu-item id="home-menu-item-cookies" label="Cookies" [toggle]="false"
(click)="document.querySelector('#cookie-modal')['visible'] = true"></sh-menu-item> -->
<sh-menu-item id="home-menu-item-privacy-notice" [attr.label]="'home.settings.privacyNotice' | transloco" [toggle]="false"
(click)="openURL(privacyNoticeUrl,$event)"></sh-menu-item>
<sh-menu-item id="home-menu-item-third-party-licenses" [attr.label]="'home.settings.thirdPartyLicenses' | transloco" [toggle]="false" (click)="openLicensePage()"></sh-menu-item>
<sh-divider id="home-divider-92"></sh-divider>
<sh-menu-item id="home-menu-item-sign-out" [attr.label]="'home.settings.signOut' | transloco" [toggle]="false" icon="sign-out" (click)="onLogoutClick()"></sh-menu-item>
</sh-popover>
@if (businessPartnerManagerOpen) {
  <app-business-partner-management (closed)="closeBusinessPartnerManager()"></app-business-partner-management>
}
<!-- Notification Center -->
<sh-notifications id="home-notifications-56" style="width: 320px">
  <app-subscribed-notifications [mode]="'notification'"></app-subscribed-notifications>
  <!-- Idle session timeout notification -->
  @if (idleWarningSeconds$ | async; as seconds) {
    <sh-notification-item id="idle-timeout-notification"
      [visible]="true"
      [sticky]="true"
      type="warning"
      [attr.label]="'home.notification.sessionTimeout.title' | transloco"
      icon="clock">
      {{ 'home.notification.sessionTimeout.message' | transloco:{ seconds: seconds } }}
      <sh-button slot="footer" color="secondary" size="m" [attr.label]="'home.notification.sessionTimeout.stayLoggedIn' | transloco" style="width: 100%;" (click)="onStayLoggedIn()"></sh-button>
    </sh-notification-item>
  }
</sh-notifications>
</sh-page>
}

@if (!isInitialLoading && isInitialError) {
  <sh-page id="home-page-94" [scrollable]="false" layout="normal" access-bar="solid">
    <sh-empty-state id="home-empty-state-please-try-again-later-if" [attr.header]="'home.error.loadingApp.header' | transloco"
      [attr.label]="'home.error.loadingApp.message' | transloco"
    icon="error" icon-color="grey"></sh-empty-state>
  </sh-page>
}

@if (!isInitialLoading && !isInitialError && showBusinessPartnerNotOnboardedState) {
  <sh-page id="home-page-96" scrollable="false"
    layout="normal" access-bar="solid">
    <sh-access-bar id="home-access-bar-97" [label]='title' slot='access' layout='classic'>
      @if (userData['photo'] !== null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo' image="url({{userData['photo']}})"></sh-user-identifier>
      }
      @if (userData['photo'] === null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo'></sh-user-identifier>
      }
      <sh-icon id="home-icon-sign-out" button icon="sign-out" size="s" (click)="onLogoutClick()" slot="functions"></sh-icon>
    </sh-access-bar>
    <div style="display: flex; flex-direction: column; gap: 12px; justify-content: center; align-items: center; height: 100%;">
      <sh-empty-state id="home-empty-state-your-account-or-domain-is" style="height: auto"
        [attr.header]="'home.accessDenied.header' | transloco"
        [attr.label]="'home.accessDenied.message' | transloco"
        icon="lock"
        icon-color="grey">
      </sh-empty-state>
    </div>
  </sh-page>
}

@if (!isInitialLoading && !isInitialError && environment.businessPartnerMode && bpAccessError) {
  <sh-page id="home-page-102" scrollable="false"
    layout="normal" access-bar="solid">
    <sh-access-bar id="home-access-bar-103" [label]='title' slot='access' layout='classic'>
      @if (userData['photo'] !== null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo' image="url({{userData['photo']}})"></sh-user-identifier>
      }
      @if (userData['photo'] === null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo'></sh-user-identifier>
      }
      <sh-icon id="home-icon-sign-out" button icon="sign-out" size="s" (click)="onLogoutClick()" slot="functions"></sh-icon>
    </sh-access-bar>
    <div style="display: flex; flex-direction: column; gap: 16px; justify-content: center; align-items: center; height: 100%;">
      <sh-empty-state id="home-empty-state-the-application-could-not" style="height: auto"
        [attr.header]="'home.accessError.header' | transloco"
        [attr.label]="'home.accessError.message' | transloco"
        icon="error"
        icon-color="grey">
      </sh-empty-state>
      <sh-button id="home-button-retry" [attr.label]="'home.accessError.button.retry' | transloco" icon="refresh" icon-position="left" (click)="retryBusinessPartnerAccess()"></sh-button>
    </div>
  </sh-page>
}

@if (!isInitialLoading && !isInitialError && showRoleRequestState) {
  <sh-page id="home-page-109" scrollable="false" layout="normal"
    access-bar="solid">
    <sh-access-bar id="home-access-bar-110" [label]='title' slot='access' layout='classic'>
      @if (userData['photo'] !== null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo' image="url({{userData['photo']}})"></sh-user-identifier>
      }
      @if (userData['photo'] === null) {
        <sh-user-identifier id="home-user-identifier-user-image" [attr.aria-label]="'home.accessBar.userImage' | transloco" slot='functions'
          style="scale: transform; pointer-events: none;"
          [name]='userData["basic"]["givenName"] + " " + userData["basic"]["surname"]'
        [info]='userIdentifierInfo'></sh-user-identifier>
      }
      <sh-icon id="home-icon-sign-out" button icon="sign-out" size="s" (click)="onLogoutClick()" slot="functions"></sh-icon>
    </sh-access-bar>
    <div style="display: flex; flex-direction: column; gap: 12px; justify-content: center; align-items: center;">
      <sh-empty-state id="home-empty-state-information" style="height: auto" [attr.header]="'home.roleRequest.header' | transloco"
        [label]="roleRequestMessage" icon="information"
      icon-color="grey"></sh-empty-state>
      <sh-text id="home-text-115" style="text-align: center; font-weight: 800; text-decoration: underline;">{{ requestedAccessRole }}</sh-text>
      <sh-button id="home-button-get-access-here" style="margin-top: 24px" size="l" [attr.label]="'home.roleRequest.button' | transloco" (click)="openGAMA()"></sh-button>
    </div>
  </sh-page>
}

<app-info-modal></app-info-modal>